<template>
  <div>
    <p
        v-if="message"
        class="message-response mb-7"
    >{{ message }}</p>
    <otp-form-input
        :on-ready-to-submit="onReadyToSubmit"
        :loading="loading"
        :error="error"
    />
    <p
        v-if="error"
        class="mt-7 red--text"
    >
      {{ error }}
    </p>

    <div @click="goBack" class="mt-8 d-flex justify-center align-center link">
      <v-icon class="icon-retry mr-1"></v-icon>
      <span>Retry with another number</span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import OtpFormInput from "../partials/OtpFormInput";
import defaultDataProvider from "@/services/identity-authen/defaultDataProvider";
import loginService from "@/services/identity-authen/loginService";
import resetTotpService from "@/services/resetTotpService";
import {setItem, removeItem} from "@/services/cookies.service";

const dataProvider = defaultDataProvider();

export default Vue.extend({
  name: "EnterOTP",
  components: { OtpFormInput },
  data() {
    return {
      message: resetTotpService.resetTotpData.message,
      loading: false,
      error: ''
    }
  },
  beforeDestroy() {
    removeItem('mfa-reset-token');
  },
  methods: {
    async onReadyToSubmit({otp}) {
      const prepareRes = loginService.getPrepareLoginResponse();
      const userInfo = prepareRes.user_info;
      const requestId = resetTotpService.resetTotpData.request_id;
      const accessToken = resetTotpService.resetTotpData.token;
      try {
        const data = await dataProvider.execute('MfaReset', {
          'ctx.domain_id': userInfo.domain_id,
          'user_id': userInfo.user_id,
          body: {
            ctx: {
              access_token: accessToken
            },
            mfa_type: "Totp",
            request_id: requestId,
            "otp": otp
          }
        }, {}, );
        if (data.obj.error_info && data.obj.error_info.error_code) {
          this.error = data.obj.error_info.message;
          return;
        }
        removeItem('mfa-reset-token');
        loginService.setPrepareLoginResponse(data.obj);
        this.$router.push({ name: 'totp-login' });
      } catch (e) {
        this.error = e.message;
      } finally {

      }
    },
    goBack() {
      this.$router.push({ name: 'reset-totp-enter-phone'})
    }
  }
})
</script>

<style scoped>

</style>